<template>
  <page-view title>
    <div slot="headerContent"></div>
    <div :style="{ marginBottom: '10px' }">
      <demo-video-alert name="JiChuSheZhi"></demo-video-alert>
    </div>
    <a-spin :spinning="PullLoading">
      <a-card title="基础设置" :bordered="false">
        <template slot="extra">
          <search-robot-input
            class="search-robot-input"
            :showInfo="false"
            :selectFirst="false"
            primaryBtnText="拉取配置"
            @changeRobotId="onChangeRobotId"
          ></search-robot-input>
        </template>
        <a-alert
          v-if="!robotid"
          :style="{ margin: '10px 0 20px 0' }"
          message="重要提醒"
          description="当前显示的系统默认数据，如需加载指定机器人数据请在右上角输入框进行拉取配置操作。"
          type="warning"
          show-icon
        />
        <a-alert
          v-if="robotid"
          :style="{ margin: '10px 0 20px 0' }"
          message="已经拉取机器人配置"
          type="success"
          show-icon
        />
        <!-- form表单--开始 -->
        <a-form :form="form" class="is-error">
          <a-form-item
            label="自动同意入群申请"
            :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
            :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
          >
            <a-switch v-decorator="['auto_agree_join_group', { initialValue: true, valuePropName: 'checked' }]" />
          </a-form-item>
          <a-divider :dashed="true" />
          <a-form-item
            label="自动同意好友申请"
            :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
            :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
          >
            <a-switch v-decorator="['auto_agree_add_friends', { initialValue: true, valuePropName: 'checked' }]" />
          </a-form-item>
          <div v-show="formData['auto_agree_add_friends'] == true">
            <a-form-item
              label="通过未知性别好友申请"
              :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
              :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
            >
              <a-switch
                v-decorator="['auto_agree_add_friends_unkown', { initialValue: true, valuePropName: 'checked' }]"
              />
            </a-form-item>
            <a-form-item
              label="通过好友性别"
              :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
              :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
            >
              <a-radio-group v-decorator="['auto_agree_add_friends_sex', { initialValue: 0 }]">
                <a-radio :value="0">全部</a-radio>
                <a-radio :value="1">男</a-radio>
                <a-radio :value="2">女</a-radio>
              </a-radio-group>
            </a-form-item>
            <!-- 为这个item添加一个 这2个class类名，是为了滚动时候，向上多滚动一些 -->
            <a-form-item
              label="验证信息包括"
              class="auto_add_friends_a_day auto_agree_add_friends_left_limit add_friends_manual_send_msg_limit"
              help="可填写多个关键字，关键字通过 | 进行分割"
              :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
              :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
            >
              <a-input
                style="width: 180px"
                placeholder="关键字"
                v-decorator="['check_keys', { rules: [{ required: false, message: '必填项' }] }]"
              />则不通过，不填写不进行判断
            </a-form-item>
            <a-form-item
              label="每天同意好友请求个数"
              :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
              :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
            >
              <a-input-number
                :min="0"
                v-decorator="[
                  'auto_add_friends_a_day',
                  { initialValue: 50, rules: [{ required: true, message: '必填项' }] },
                ]"
                :formatter="value => `${value}个`"
                :parser="value => value.replace('个', '')"
              />
            </a-form-item>
            <a-form-item
              label="自动同意好友申请间隔"
              :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
              :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
            >
              <a-input-number
                :min="0"
                :max="maxTime"
                v-decorator="[
                  'auto_agree_add_friends_left_limit',
                  { initialValue: 0, rules: [{ required: true, message: '必填项' }] },
                ]"
                :formatter="value => (value ? `${value}秒` : value)"
                :parser="value => value.replace('秒', '')"
              />
              ~
              <a-input-number
                :min="0"
                v-decorator="[
                  'auto_agree_add_friends_limit',
                  { initialValue: 0, rules: [{ required: true, message: '必填项' }] },
                ]"
                :formatter="
                  value => {
                    maxTime = Number(value)
                    return `${value}秒`
                  }
                "
                :parser="value => value.replace('秒', '')"
              />
            </a-form-item>
          </div>
          <a-divider :dashed="true" />
          <div>
            <a-form-item
              label="添加好友主动发消息"
              :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
              :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
            >
              <a-switch
                v-decorator="['add_friends_manual_send_msg', { initialValue: true, valuePropName: 'checked' }]"
              />
            </a-form-item>
            <div v-show="formData['add_friends_manual_send_msg'] == true">
              <a-form-item
                label="添加好友主动发消息间隔"
                help="间隔最高30秒"
                :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
                :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
              >
                <a-input-number
                  :min="0"
                  :max="30"
                  v-decorator="[
                    'add_friends_manual_send_msg_limit',
                    { initialValue: 0, rules: [{ required: true, message: '必填项' }] },
                  ]"
                  :formatter="value => `${value}秒`"
                  :parser="value => value.replace('秒', '')"
                />
              </a-form-item>

              <!-- 僵尸粉监测功能 -->
              <!-- <a-form-item label="检测僵尸粉" help="启动被动处理僵尸粉"
                :label-col="{ xs: { span: 24 }, sm: { span: 4 } }" :wrapper-col="{ xs: { span: 24 }, sm: { span: 16 } }" >
                <a-switch v-decorator="['check_zombie_fan', { initialValue: false, valuePropName: 'checked' }]"/>
                <a style="font-size: 16px; margin:0 10px;">
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>给买家发送消息时，系统发现对方已经删除自己，执行此操作</span>
                    </template>
                    <a-icon type="question-circle" />
                  </a-tooltip>
                </a>
                <a-input style="width: 300px" placeholder="支持参数: [昵称]、[备注]、[时间]"
                  v-decorator="['check_fan_name', { initialValue: '删-[昵称]-[备注]-[时间]' }]" />
                <a>支持参数: [昵称]-[备注]-[时间]</a>
              </a-form-item> -->

              <a-form-item
                label="添加好友招呼消息设置"
                :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
                :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
              >
                <a-button type="primary" @click="handleZhaohuSetting">设置</a-button>
              </a-form-item>
              <a-form-item :style="{ display: 'none' }">
                <a-input v-decorator="['manual_response']" />
              </a-form-item>
              <a-form-item
                label="重复添加好友招呼消息设置"
                :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
                :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
              >
                <a-button type="primary" @click="handleRepeatZhaohuSetting">设置</a-button>
              </a-form-item>
              <a-form-item :style="{ display: 'none' }">
                <a-input v-decorator="['repeat_response']" />
              </a-form-item>
            </div>
          </div>
          <a-divider :dashed="true" />
          <a-form-item
            label="首次添加好友奖励"
            :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
            :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
          >
            <a-switch
              v-decorator="['first_add_friends_reward_switch', { initialValue: true, valuePropName: 'checked' }]"
            />
          </a-form-item>
          <div v-show="formData['first_add_friends_reward_switch'] == true">
            <a-form-item
              label="首次添加好友奖励金额"
              :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
              :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
            >
              <a-input-number
                :min="0"
                v-decorator="[
                  'first_add_friends_reward_balance',
                  { initialValue: 0, rules: [{ required: true, message: '必填项' }] },
                ]"
                :formatter="value => `${value}元`"
                :parser="value => value.replace('元', '')"
              />
            </a-form-item>
            <a-form-item
              label="是否直接奖励红包"
              :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
              :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
              extra="是否直接发红包，不选中则奖励到用户余额（选中情况下，最低设置0.3元红包，否则红包发送失败）"
            >
              <a-switch v-decorator="['first_add_friends_reward_packet', { valuePropName: 'checked' }]" />
            </a-form-item>
          </div>
          <a-divider :dashed="true" />
          <a-form-item
            label="返利群组入群欢迎消息开启"
            help="需要在群组管理中添加返利群组"
            :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
            :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
          >
            <a-switch
              v-decorator="['into_group_welcome_message_switch', { initialValue: false, valuePropName: 'checked' }]"
            />
          </a-form-item>
          <div v-show="formData['into_group_welcome_message_switch'] == true">
            <a-form-item
              label="返利群组入群欢迎消息文案"
              :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
              :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
            >
              <a-textarea :rows="6" placeholder="请输入" v-decorator="['into_group_welcome_message_text']" />
            </a-form-item>
          </div>
          <a-divider :dashed="true" />
          <a-form-item
            label="首次下单奖励金额"
            :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
            :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
          >
            <a-input-number
              :min="0"
              v-decorator="['first_pay_reward', { initialValue: 0, rules: [] }]"
              :formatter="value => `${value}元`"
              :parser="value => value.replace('元', '')"
            />
          </a-form-item>
          <a-form-item
            label="付款即奖励"
            :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
            :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
          >
            <a-switch v-decorator="['first_pay_Combined_order', { initialValue: false, valuePropName: 'checked' }]" />
          </a-form-item>
          <a-form-item
            label="是否奖励红包"
            help="如果打开此开关直接发送红包，最低0.3元，低于0.3发送失败奖励将会发放到用户余额。不打开直接到余额，打开此开关需在回复文案中添加[红包卡片]变量"
            :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
            :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
          >
            <a-switch v-decorator="['reward_packet', { initialValue: false, valuePropName: 'checked' }]" />
          </a-form-item>
          <a-divider :dashed="true" />
          <!-- 为这个item添加一个 这2个class类名，是为了滚动时候，向上多滚动一些 -->
          <a-form-item
            label="订单冻结开关"
            class="limit_withdraw_money limit_withdraw_time"
            :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
            :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
          >
            <a-switch v-decorator="['limit_withdraw_switch', { initialValue: true, valuePropName: 'checked' }]" />
          </a-form-item>
          <div v-show="formData['limit_withdraw_switch'] == true">
            <a-form-item
              label="用户佣金超过此金额冻结订单"
              :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
              :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
            >
              <a-input-number
                :min="0"
                v-decorator="[
                  'limit_withdraw_money',
                  {
                    initialValue: 0,
                    rules: [{ required: formData['limit_withdraw_switch'] == true ? true : false, message: '必填项' }],
                  },
                ]"
                :formatter="value => `${value}元`"
                :parser="value => value.replace('元', '')"
              />
            </a-form-item>
            <a-form-item
              label="订单冻结天数"
              :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
              :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
            >
              <a-input-number
                :min="0"
                v-decorator="[
                  'limit_withdraw_time',
                  {
                    initialValue: 0,
                    rules: [{ required: formData['limit_withdraw_switch'] == true ? true : false, message: '必填项' }],
                  },
                ]"
                :formatter="value => `${value}天`"
                :parser="value => value.replace('天', '')"
              />
            </a-form-item>
          </div>
          <a-divider :dashed="true" />
          <a-form-item
            label="添加好友邀请入群"
            extra="请到“机器人列表-配置页面”修改微信群ID"
            :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
            :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
          >
            <a-switch
              v-decorator="['auto_invite_friends_to_group', { initialValue: false, valuePropName: 'checked' }]"
            />
          </a-form-item>
          <a-divider :dashed="true" />
          <a-form-item
            label="消息互换"
            extra="机器人手机端—用户消息互换"
            :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
            :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
          >
            <a-switch v-decorator="['isok_lyxxhh', { initialValue: true, valuePropName: 'checked' }]" />
          </a-form-item>
          <a-divider :dashed="true" />
          <a-form-item
            label="自动清理微信缓存"
            extra="每天凌晨4点半自动清理"
            :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
            :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
          >
            <a-switch v-decorator="['auto_clear_wx_cache_switch', { initialValue: false, valuePropName: 'checked' }]" />
          </a-form-item>
          <a-divider :dashed="true" />
          <a-form-item
            label="静默更新"
            :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
            :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
          >
            <a-switch v-decorator="['updata_quiet', { initialValue: false, valuePropName: 'checked' }]" />
          </a-form-item>
          <a-divider :dashed="true" />
          <a-form-item
            label="购买链接使用短链接"
            :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
            :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
          >
            <a-select v-decorator="['short_link', { initialValue: 0 }]">
              <a-select-option :value="0">不使用短链</a-select-option>
              <!--              <a-select-option :value="1">万缩短链</a-select-option>-->
              <a-select-option :value="2">快码短链</a-select-option>
              <!-- <a-select-option :value="2">快站短链</a-select-option> -->
              <!-- <a-select-option :value="3">缩我短链</a-select-option> -->
              <!-- <a-select-option :value="5">微信短链</a-select-option> -->
              <!-- <a-select-option :value="4">百度短链</a-select-option> -->
            </a-select>
          </a-form-item>
          <div v-show="formData['short_link'] == 2">
            <a-form-item
              label="快码APP_KEY"
              :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
              :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
            >
              <a-input v-decorator="['kuaima_appkey']" />
              <div slot="help">
                <a href="https://kuaima.kuaizhan.com/" target="_blank">如何获取快码APP_KEY?</a>
              </div>
            </a-form-item>
          </div>
          <div v-show="false">
            <a-form-item
              label="微信key"
              :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
              :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
            >
              <a-input v-decorator="['wechat_appkey']" />
            </a-form-item>
            <a-form-item
              label="微信密钥"
              :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
              :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
            >
              <a-input v-decorator="['wechat_appsecret']" />
            </a-form-item>
          </div>
          <a-divider :dashed="true" />
          <a-form-item
            label="订单消息通知购买者"
            :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
            :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
          >
            <a-switch v-decorator="['send_order_to_buyer', { initialValue: true, valuePropName: 'checked' }]" />
          </a-form-item>
          <a-form-item
            label="订单消息通知上级"
            :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
            :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
          >
            <a-switch v-decorator="['send_order_to_superiors', { initialValue: true, valuePropName: 'checked' }]" />
          </a-form-item>
          <a-form-item
            label="订单消息通知上上级"
            :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
            :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
          >
            <a-switch v-decorator="['send_order_to_second', { initialValue: true, valuePropName: 'checked' }]" />
          </a-form-item>
          <a-form-item
            label="订单消息通知群主"
            :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
            :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
          >
            <a-switch v-decorator="['send_order_to_group_master', { initialValue: true, valuePropName: 'checked' }]" />
          </a-form-item>
          <a-form-item
            label="消息强制推送到群组"
            :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
            :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
          >
            <a-switch v-decorator="['message_to_group', { initialValue: false, valuePropName: 'checked' }]" />
          </a-form-item>
          <a-divider :dashed="true" />
          <a-form-item
            label="开启呼叫客服功能"
            :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
            :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
          >
            <a-switch v-decorator="['call_customer_switch', { initialValue: false, valuePropName: 'checked' }]" />
          </a-form-item>
          <div v-show="formData['call_customer_switch'] == true">
            <a-form-item
              label="呼叫客服关键字"
              help="开启后通过公众号消息通知"
              :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
              :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
            >
              <a-input v-decorator="['call_customer_text']" />
            </a-form-item>
            <a-form-item
              label="自动回复文案"
              :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
              :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
            >
              <a-textarea v-decorator="['call_customer_message']" />
            </a-form-item>
          </div>
          <a-divider :dashed="true" />
          <a-form-item
            label="IM客服系统开关"
            help="使用客服系统时打开，不使用建议关闭"
            :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
            :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
          >
            <a-switch v-decorator="['im_service_switch', { initialValue: false, valuePropName: 'checked' }]" />
          </a-form-item>
          <a-divider :dashed="true" />
          <a-form-item
            label="选择机器人"
            class="robotids"
            :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
            :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
          >
            <robot-multiple
              v-decorator="['robotids', { rules: [{ required: true, message: '必填项' }] }]"
            ></robot-multiple>
          </a-form-item>
          <a-form-item :wrapper-col="{ xs: { span: 12, offset: 0 }, sm: { span: 12, offset: 4 } }">
            <a-button htmlType="submit" type="primary" @click="handleSubmit">推送</a-button>
          </a-form-item>
        </a-form>
        <!-- form表单--结束 -->
      </a-card>
    </a-spin>
    <zhaohu-modal ref="zhaohuModal" @ok="handleZhaohuChange"></zhaohu-modal>
    <repeat-zhaohu-modal ref="repeatZhaohuModal" @ok="handleRepeatZhaohuChange"></repeat-zhaohu-modal>
  </page-view>
</template>

<script>
import SearchRobotInput from '@/views/components/SearchRobotInput'
import TriggerTags from '@/views/components/TriggerTags'
import RobotMultiple from '@/views/components/RobotMultiple'
import DeviceApi from '@/api/device'
import { PageView } from '@/layouts'
import { mapActions } from 'vuex'
import ZhaohuModal from '@/views/settings/modules/ZhaohuModal'
import RepeatZhaohuModal from '@/views/settings/modules/RepeatZhaohuModal'
import DemoVideoAlert from '@/views/components/DemoVideoAlert'
export default {
  name: 'BasicSetting',
  data() {
    return {
      formData: {},
      form: this.$form.createForm(this, {
        onValuesChange: (_, values) => {
          Object.assign(this.formData, values)
        },
      }),
      PullLoading: false,
      robotid: null,
      maxTime: 0,
    }
  },
  components: {
    PageView,
    SearchRobotInput,
    TriggerTags,
    RobotMultiple,
    ZhaohuModal,
    DemoVideoAlert,
    RepeatZhaohuModal,
  },
  created() {
    this.getData()
  },
  methods: {
    ...mapActions(['BatchpushSigninConfig', 'TaskDrawerSwitch', 'BatchpushTask', 'demoSetVideo']),

    // 提交
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        console.log('err=',err);
        if(err){
          // 这里是滚动到“必填项”没填的那个框框
          let errClassName = Object.keys(err)
          // console.log('err=',errClassName)
          if(errClassName){
            this.$nextTick(() => {
              let isError = document.getElementsByClassName(errClassName[0])
              isError[0].scrollIntoView({
                // 滚动到指定节点
                // 值有start,center,end，nearest，当前显示在视图区域中间
                block: 'start',
                // 值有auto、instant,smooth，缓动动画（当前是慢速的）
                behavior: 'smooth',
              })
            })
          }
        }

        if (!err) {
          // this.BatchpushSigninConfig({ robotids: values.robotids, data: values })
          this.BatchpushTask({
            robotids: values.robotids,
            descs: '基础配置',
            apiFun: sub_id => {
              return DeviceApi.saveBasicSettingInfo(Object.assign({ sub_id: sub_id }, values))
            },
          })
          this.TaskDrawerSwitch({ status: true })
          this.form.resetFields('robotids')
        }
      })
    },
    // 选择机器人
    onChangeRobotId(robotid) {
      this.robotid = robotid
      this.getData(robotid)
    },
    // 获取配置信息
    getData(robotid) {
      this.PullLoading = true
      DeviceApi.getBasicSettingInfo({ sub_id: robotid })
        .then(res => {
          if (res.code === 1) {
            this.form.setFieldsValue({
              auto_agree_join_group: res.data.auto_agree_join_group,
              auto_add_friends_a_day: res.data.auto_add_friends_a_day,
              auto_agree_add_friends: res.data.auto_agree_add_friends,
              auto_agree_add_friends_limit: res.data.auto_agree_add_friends_limit,
              auto_agree_add_friends_left_limit: res.data.auto_agree_add_friends_left_limit,
              add_friends_manual_send_msg: res.data.add_friends_manual_send_msg,
              add_friends_manual_send_msg_limit: res.data.add_friends_manual_send_msg_limit,
              check_keys: res.data.check_keys,
              first_add_friends_reward_switch: res.data.first_add_friends_reward_switch,
              first_add_friends_reward_balance: res.data.first_add_friends_reward_balance,
              updata_quiet: res.data.updata_quiet,
              isok_lyxxhh: res.data.isok_lyxxhh,
              send_order_to_buyer: res.data.send_order_to_buyer,
              send_order_to_superiors: res.data.send_order_to_superiors,
              send_order_to_second: res.data.send_order_to_second,
              send_order_to_group_master: res.data.send_order_to_group_master,
              manual_response: res.data.manual_response,
              repeat_response: res.data.repeat_manual_response,
              first_pay_reward: res.data.first_pay_reward,
              limit_withdraw_switch: res.data.limit_withdraw_switch,
              limit_withdraw_time: res.data.limit_withdraw_time,
              limit_withdraw_money: res.data.limit_withdraw_money,
              short_link: res.data.short_link || 0,
              kuaima_appkey: res.data.kuaima_appkey,
              wechat_appsecret: res.data.wechat_appsecret,
              wechat_appkey: res.data.wechat_appkey,
              message_to_group: res.data.message_to_group,
              auto_invite_friends_to_group: res.data.auto_invite_friends_to_group,
              first_add_friends_reward_packet: res.data.first_add_friends_reward_packet,
              first_pay_Combined_order: res.data.first_pay_Combined_order,
              // 首单是否奖励
              reward_packet: res.data.reward_packet,
              call_customer_switch: res.data.call_customer_switch,
              call_customer_text: res.data.call_customer_text,
              call_customer_message: res.data.call_customer_message,
              im_service_switch: res.data.im_service_switch,
              auto_clear_wx_cache_switch: res.data.auto_clear_wx_cache_switch,
              into_group_welcome_message_switch: res.data.into_group_welcome_message_switch,
              into_group_welcome_message_text: res.data.into_group_welcome_message_text,
              auto_agree_add_friends_sex: res.data.auto_agree_add_friends_sex,
              auto_agree_add_friends_unkown: res.data.auto_agree_add_friends_unkown,
            })
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
          this.PullLoading = false
        })
    },
    handleZhaohuSetting() {
      const data = this.form.getFieldValue('manual_response')
      this.$refs.zhaohuModal.show(data)
    },
    handleRepeatZhaohuSetting() {
      const data = this.form.getFieldValue('repeat_response')
      this.$refs.repeatZhaohuModal.show(data)
    },
    handleZhaohuChange(data) {
      this.form.setFieldsValue({
        manual_response: data,
      })
    },
    handleRepeatZhaohuChange(data) {
      this.form.setFieldsValue({
        repeat_response: data,
      })
    },
    doCopy(text) {
      this.$copyText(text)
        .then(message => {
          this.$message.success('复制完毕')
        })
        .catch(err => {
          this.$message.error('复制失败')
        })
    },
  },
}
</script>
<style lang="less" scoped>
/deep/ .page-header {
  .extra {
    display: none;
  }
  .headerContent {
    flex: 0 1 100% !important;
  }
}
/deep/ .ant-card-extra {
  padding: 0;
}
</style>
